import { List } from 'antd';

export default List;
